<template>
  <div>
    <vue-content-loading :width="1920" :height="900" class="mb-5">
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="100" />
      <rect x="0" y="120" rx="0" ry="0" width="100%" height="50" />
      <rect x="0" y="190" rx="0" ry="0" width="66%" height="750" />
      <rect x="68%" y="190" rx="0" ry="0" width="34%" height="300" />
      <rect x="68%" y="510" rx="0" ry="0" width="34%" height="200" />
    </vue-content-loading>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading'

export default {
  name: 'detail-loader',

  components: {
    VueContentLoading,
  },

  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
